import { render, staticRenderFns } from "./snowglobe.vue?vue&type=template&id=36fbd284&scoped=true&"
import script from "./snowglobe.vue?vue&type=script&lang=js&"
export * from "./snowglobe.vue?vue&type=script&lang=js&"
import style0 from "./snowglobe.vue?vue&type=style&index=0&id=36fbd284&lang=scss&scoped=true&"
import style1 from "./snowglobe.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36fbd284",
  null
  
)

/* custom blocks */
import block0 from "./snowglobe.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {PageHeader: require('/app/components/page/header.vue').default,UiTransition: require('/app/components/ui/transition.vue').default})
